import React from 'react';
import { Link } from 'gatsby';

interface IProps {
  className?: string;
  data?: any;
  lang?: string;
  country?: string;
}

const FooterLinks = ({ data, lang }: IProps) => {
  return (
    <nav className="menu" data-gtm-action="footer" data-gtm-category="navegacion">
      {data &&
        data.map(
          (value, i) =>
            value.childrenMenuItems && (
              <ul key={'footer-link_' + i} className="menu-list">
                {value.childrenMenuItems.map((item, j) => (
                  <li key={item.value + '_' + j} className="menu-item">
                    {item.url === `/${lang}/cookies` ? (
                      <a data-gtm-event data-gtm-label={item.url} href={item.url || '#'}>
                        {item.title}
                      </a>
                    ) : (
                      <Link data-gtm-event data-gtm-label={item.url} to={item.url || '#'}>
                        {item.title}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            )
        )}
    </nav>
  );
};

export default FooterLinks;
